import { createSlice } from "@reduxjs/toolkit";

export const farmFieldsById = createSlice({
  name: "farmFieldsById",
  initialState: {
    value: {
      status: false,
      fieldData: [],
      fieldCrops: [],
      lastHarvestMainCrop: {},
      fieldId: "",
      fieldCropsDetailDump: [],
    },
  },
  reducers: {
    updateAllFieldData: (state, action) => {
      state.value.status = true;
      state.value.fieldData = action.payload?.fieldData;
      state.value.fieldCrops = action.payload?.fieldCrops;
      state.value.fieldId = action.payload?.fieldId;
      state.value.lastHarvestMainCrop = action.payload?.lastHarvestMainCrop;
    },
    updateFieldCrops: (state, action) => {
      state.value.status = true;
      state.value.fieldCrops = action.payload;
    },
    removeFieldCropById: (state, action) => {
      state.value.status = true;
      const existingData = [...state.value.fieldCrops];
      state.value.fieldCrops.forEach((item, index) => {
        if (action.payload === item._id) {
          existingData.splice(index, 1);
        }
      });
      state.value.fieldCrops = existingData;
    },
    addFieldCropDetailToBacklog: (state, action) => {
      state.value.fieldCropsDetailDump = [
        ...state.value.fieldCropsDetailDump,
        action.payload,
      ];
    },
  },
});

export const {
  updateAllFieldData,
  updateFieldCrops,
  removeFieldCropById,
  addFieldCropDetailToBacklog,
} = farmFieldsById.actions;

export default farmFieldsById.reducer;
